<template>

    <vue-select-input
        :description="description"
        :error="error"
        :focus="focus"
        :id="id"
        :label="label"
        :options="getOptions"
        :reduce="country => country.value"
        :value="value"
        @input="$emit('input', $event)"
        select-label="label"
    ></vue-select-input>

</template>

<script>

import { mapActions, mapGetters } from "vuex";
import VueSelectInput from "./VueSelectInput";

export default {

    components: {
        VueSelectInput,
    },

    computed: {

        ...mapGetters([
            'getCountries',
        ]),

        getOptions() {
            return this.getCountries;
        },

    },

    methods:{

        ...mapActions([
            'fetchCountries'
        ]),
    },

    mounted() {
        this.fetchCountries();
    },

    props:{
        description:{
            type:String,
            default:null,
        },
        error:{
            type:String,
            default:'',
        },
        focus:{
            type:Boolean,
            default:false,
        },
        id:{
            type:String,
            default(){
                return `select-${this._uid}`
            },
        },
        label:{
            required:true,
            type:String,
        },
        value:{
            required:true,
        },
    },
}

</script>
